import BurgerIngredientTypes from './burger-ingredient-types';

const prices = {};
prices[BurgerIngredientTypes.SALAD] = 0.5;
prices[BurgerIngredientTypes.CHEESE] = 0.4;
prices[BurgerIngredientTypes.MEAT] = 1.3;
prices[BurgerIngredientTypes.BACON] = 0.7;

export default prices;